function siteMenuFn() {
	let mobileornot = '';
	const hamburger = document.querySelector('.site-header button.hamburger');
	const globalHeader = document.querySelector('.global-header');
	const siteHeader = document.querySelector('.site-header');
	const siteHeaderList = document.querySelector('.site-header-list');
	const siteHeaderItems = document.querySelectorAll('.site-header-item');

	// Submenu items
	const sitemenuitems = document.querySelectorAll('.site-header-item.has-subitems');
	const sitemenuitemlinks = document.querySelectorAll('.site-header-item.has-subitems .site-header-item-link');
	const sitemenuitemwrappers = document.querySelectorAll('.site-header-item.has-subitems .site-header-item-wrapper');
	const sitemenuitemclosers = document.querySelectorAll('.site-header-item.has-subitems .site-header-item-back');

	// Mobile
	function openMobileSubMenu(el, e) {
		if (mobileornot == '') {
			sitemenuitems.forEach(item =>
				item.classList.remove('open')
			);

			siteHeaderList.classList.add('item-open');
			el.parentElement.parentElement.classList.add('open');
			e.preventDefault();
		}
	}
	function removeOpen(el, e) {
		if (mobileornot == '') {
			siteHeaderList.classList.remove('item-open');
			el.parentElement.parentElement.classList.remove('open');
			e.preventDefault();
		}
	}
	sitemenuitemlinks.forEach(item =>
		item.addEventListener('click', () => openMobileSubMenu(item, event), true)
	);

	sitemenuitemclosers.forEach(item =>
		item.addEventListener('click', () => removeOpen(item, event), true)
	);

	// Desktop
	function addHovered(el) {
		if (mobileornot == 'not') {
			el.parentElement.classList.add('hovered');
		}
	}
	function removeHovered(el) {
		if (mobileornot == 'not') {
			el.parentElement.classList.remove('hovered');
		}
	}
	sitemenuitemwrappers.forEach(item =>
		item.addEventListener('mouseover', () => addHovered(item), true)
	);
	sitemenuitemwrappers.forEach(item =>
		item.addEventListener('mouseout', () => removeHovered(item), true)
	);

	hamburger.addEventListener('click', function() {
		if (!hamburger.classList.contains('open')) {
			siteHeader.classList.add('open');
			hamburger.classList.add('open');
		} else {
			siteHeader.classList.remove('open');
			hamburger.classList.remove('open');

			setTimeout(function(){
				siteHeaderItems.forEach(function(item) {
					siteHeaderList.classList.remove('item-open');
					item.classList.remove('open');
				});
			}, 300);
		}
	});

	/* Header dropdown */
	const dropdownButton = document.querySelector('.language-dropdown-button');
	const dropdownContent = document.querySelector('.language-dropdown-content');

	dropdownButton.addEventListener('click', () => {
		dropdownContent.classList.toggle('show');
	});

	window.addEventListener('click', event => {
		if (!event.target.matches('.language-dropdown-button')) {
			//dropdownContent.classList.remove('show');
		}
	});

	// Site Header Changes
	if(window.IntersectionObserver) {
		/* Fixed */
		/*const globalHeaderIntersectionOptions = {
			root: null,
			// rootMargin: '0px 0px 0px 0px',
			threshold: 0
		};
		const globalHeaderObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					siteHeader.classList.remove('fixed');
				} else {
					siteHeader.classList.add('fixed');
					// observer.unobserve(header.target);
				}
			});
		}, globalHeaderIntersectionOptions);
		globalHeaderObserver.observe(globalHeader);*/

		/* BG Colour */
		const heroBlock = document.querySelector('.block.hero');
		let hThreshold;
		if (document.body.classList.contains('home')) {
			hThreshold = '0.7';
		} else {
			hThreshold = '0.9';
		}
		const heroObserver = new IntersectionObserver(function(entries) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					siteHeader.classList.remove('bg');
				} else {
					siteHeader.classList.add('bg');
				}
			});
		}, {threshold: hThreshold});
		heroObserver.observe(heroBlock);
	}

	const desktopQuery = window.matchMedia('(min-width: 1200px)')
	function handleDesktopQueryChange(e) { if (e.matches) {
		mobileornot = 'not';
	} else {
		mobileornot = '';
	}}
	desktopQuery.addEventListener('change', handleDesktopQueryChange);
	handleDesktopQueryChange(desktopQuery);
}

const siteMenu = {
	init: function() {
		siteMenuFn();
	},
};

export default siteMenu;
